import {
  useCallback,
  useEffect,
  useState,
} from "react";

import {
  getPublicTutorial,
  getPublicTutorialErrorMessage,
} from "../../../../services/publicTutorialServices";

import {
  TUTORIAL_CONFIG,
} from "../../../../config/tutorialConfig";

export default function usePublicTutorial({
  role = null,
  version = null,
} = {}) {
  const [data, setData] =
    useState(null);

  const [loading, setLoading] =
    useState(true);

  const [refreshing, setRefreshing] =
    useState(false);

  const [error, setError] =
    useState(null);

  const loadTutorial = useCallback(
    async ({
      silent = false,
      signal,
    } = {}) => {
      try {
        if (silent) {
          setRefreshing(true);
        } else {
          setLoading(true);
        }

        setError(null);

        const result =
          await getPublicTutorial({
            appKey:
              TUTORIAL_CONFIG.appKey,

            siteKey:
              TUTORIAL_CONFIG.siteKey,

            locale:
              TUTORIAL_CONFIG.locale,

            role,
            version,
            signal,
          });

        setData(result);

        return result;
      } catch (loadError) {
        const message =
          getPublicTutorialErrorMessage(
            loadError
          );

        if (message) {
          console.error(
            "Chargement du tutoriel :",
            loadError
          );

          setError(message);
          setData(null);
        }

        return null;
      } finally {
        setLoading(false);
        setRefreshing(false);
      }
    },
    [role, version]
  );

  useEffect(() => {
    const controller =
      new AbortController();

    loadTutorial({
      signal: controller.signal,
    });

    return () => {
      controller.abort();
    };
  }, [loadTutorial]);

  const refresh = useCallback(
    () =>
      loadTutorial({
        silent: true,
      }),
    [loadTutorial]
  );

  return {
    data,

    tutorial:
      data?.tutorial || null,

    sections:
      data?.sections || [],

    steps:
      data?.steps || {},

    faqs:
      data?.faqs || [],

    loading,
    refreshing,
    error,
    refresh,
  };
}